exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-outfits-message[data-v-70c574ec] {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  font-size: 20px;\n}", ""]);

// exports
